import BaseComponent from '../../../general/js/base-component';
import eventBus from '../../../general/js/event-bus';
import stylesFinally from '../../../general/js/style-observer'
import {EVENT_DEVICE_TYPE_CHANGED} from '../../../general/js/app';

export default class TabsComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.contentHolder = this.refs.contentHolder;

        stylesFinally(() => {
            this.init();

            eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, () => {
                setTimeout(() =>{
                    this.init();
                }, 500);
            });
            
            window.addEventListener('load', () => {
                this.init();
            });
        });
    }

    init() {
        this.setHeight();
        this.setButtonsSize();
    }

    setHeight(){
        let height = 0;

        [].forEach.call(this.contentHolder.children, (item) => {
            height = height > item.offsetHeight ? height : item.offsetHeight;
        });

        this.contentHolder.style.height = height + 'px';
    }

    setButtonsSize(){
        let labels = this.element.querySelectorAll('label.tab-label');
        let offset = 0;

        [].forEach.call(labels, (label) => {
            offset += parseInt(window.getComputedStyle(label).marginLeft);
            if(label.previousElementSibling.tagName == 'INPUT') {
                label.previousElementSibling.style.height = label.offsetHeight + 'px';
                label.previousElementSibling.style.width = label.offsetWidth + 'px';
                label.previousElementSibling.style.left = offset + 'px';
            }
            offset += label.offsetWidth + parseInt(window.getComputedStyle(label).marginRight);
        });

    }
}



// WEBPACK FOOTER //
// ./app/components/tabs/js/tabs.component.js